import React, { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'INÍCIO', href: '#home' },
  { label: 'SOBRE', href: '#about' },
  { label: 'PROJETOS', href: '#works' },
  { label: 'HABILIDADES', href: '#solutions' },
  { label: 'PROCESSO', href: '#process' },
  { label: 'TRAJETÓRIA', href: '#awards' },
  { label: 'CONTATO', href: '#contact' },
];

function MenuButton({ onOpen }) {
  return (
    <button
      onClick={onOpen}
      className="flex flex-col items-center gap-1.5 group"
      aria-label="open menu"
    >
      <span className="block h-[2px] w-8 bg-white" />
      <span className="text-sm font-semibold tracking-[0.2em] text-white/80 group-hover:text-[var(--accent)] transition-colors">
        MENU
      </span>

    </button>
  );
}

function MenuOverlay({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[10000] bg-[var(--bg)]/95 backdrop-blur-xl flex items-center justify-center"
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 md:top-8 md:right-10 text-white hover:text-[var(--accent)]"
            aria-label="close menu"
          >

            <X size={32} strokeWidth={1.5} />
          </button>

          <nav className="flex flex-col items-center gap-6">
            {NAV_LINKS.map((l, i) => (
              <motion.a
                key={l.label}
                href={l.href}
                onClick={onClose}
                initial={{ y: 40, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: i * 0.05, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="font-display text-4xl md:text-6xl tracking-tight hover:text-[var(--accent)] transition-colors"
              >

                {l.label}
              </motion.a>
            ))}
          </nav>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function useScrolled(threshold = 40) {
  const [scrolled, setScrolled] = useState(false);

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > threshold);
  }, [threshold]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return scrolled;
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const scrolled = useScrolled(40);

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className={`fixed top-0 left-0 right-0 z-[9999] transition-all duration-500 ${
          scrolled ? 'bg-black/70 backdrop-blur-md' : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between px-6 md:px-10 py-5">
          <a href="#home" className="text-sm font-semibold tracking-[0.2em] leading-tight flex flex-col md:flex-row md:gap-1.5">
            <span>MAYCON</span>
            <span>ROBERT</span>
          </a>
          <MenuButton onOpen={handleOpen} />
           <a
            href="#contact"
            className="text-sm font-semibold tracking-[0.2em] hover:text-[var(--accent)] transition-colors"
          >
            CONTATO
          </a>

        </div>
      </motion.header>

      <MenuOverlay open={open} onClose={handleClose} />
    </>
  );
}
